import axios from "axios";

export const getExtraSlideList = data => {
  const requestUrl = `/data/extra_slides`;
  let {
    pageSize,
    paginationPage,
    organizationUen,
    isHide,
    searchTitle,
    categoryListSelected
  } = data;
  const fields = [];
  let params = {
    fields: fields.join(","),
    limit: pageSize || 9,
    start: !paginationPage ? 0 : (paginationPage - 1) * pageSize,
    organizationUen: organizationUen
  };

  let filters = [];

  if (searchTitle && searchTitle.length > 0) {
    filters.push({
      property: "label",
      value: searchTitle,
      operator: "flike"
    });
  }

  if (categoryListSelected && categoryListSelected.length > 0) {
    filters.push({
      property: "category",
      value: categoryListSelected,
      operator: "inSubqueryOrNull"
    });
  }

  // eslint-disable-next-line eqeqeq
  if (isHide != "-1") {
    filters.push({
      property: "isHidden",
      value: isHide,
      operator: "eq"
    });
  }

  let sort = [];
  sort.push({
    property: "updatedAt",
    dir: "desc"
  });
  params.sort = JSON.stringify(sort);

  params.filter = JSON.stringify(filters).replace(
    /SPECIAL_CHAR_TO_REPLACE/g,
    "\\"
  );

  return axios.get(requestUrl, { params });
};

export const saveExtraSlide = ({
  title,
  content,
  organizationUen,
  extraSlideId,
  hide,
  categoryId
}) => {
  const requestUrl = `/data/extra_slide/save`;

  let formData = new FormData();
  formData.append("label", title);
  formData.append("content", content);
  formData.append("organizationUen", organizationUen);
  if (extraSlideId) {
    formData.append("extraSlideId", extraSlideId);
  }
  if (hide) {
    formData.append("isHidden", hide);
  }
  formData.append("categoryId", categoryId);
  return axios.post(requestUrl, formData);
};

export const deleteExtraSlide = ({ extraSlideId }) => {
  const requestUrl = `/data/extra_slide/delete`;

  let formData = new FormData();
  formData.append("extraSlideId", extraSlideId);
  return axios.post(requestUrl, formData);
};

export const getCategoryExtraSlideList = data => {
  const requestUrl = `/data/category_extra_slide`;
  let { organizationUen } = data;
  const fields = [];
  let params = {
    fields: fields.join(","),
    organizationUen: organizationUen
  };
  let sort = [];
  sort.push({
    property: "updatedAt",
    dir: "desc"
  });
  params.sort = JSON.stringify(sort);

  return axios.get(requestUrl, { params });
};

export const saveCategoryExtraSlide = ({
  organizationUen,
  label,
  categoryId
}) => {
  const requestUrl = `/data/category_extra_slide/save`;

  let formData = new FormData();
  formData.append("label", label);
  formData.append("organizationUen", organizationUen);
  if (categoryId) {
    formData.append("categoryId", categoryId);
  }

  return axios.post(requestUrl, formData);
};

export const deleteCategoryExtraSlide = ({ categoryId }) => {
  const requestUrl = `/data/category_extra_slide/delete`;

  let formData = new FormData();
  formData.append("categoryId", categoryId);
  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/extraSlideList.js